import PropTypes from 'prop-types';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from 'client/pages/HomePage/Workspace/WorkspaceTile/WorkspaceTile.module.scss';

const WorkspaceTile = ({ variant, header, icon, action, children, ...props }) => {
    const testId = props['data-testid'];
    return (
        <div
            className={[styles.tile, styles[variant]].join(' ')}
            data-testid={testId}
        >
            <div className={styles.content}>
                {icon &&
                    <div
                        className={styles.icon}
                        data-testid={testId + '.icon'}
                    >
                        {icon}
                        {header &&
                            <h2
                                className={styles.header}
                                data-testid={testId + '.header'}
                            >
                                {header}
                            </h2>

                        }
                    </div>
                }
                <div className={styles.children}>
                    {children}
                </div>
            </div>
            {action && <div className={styles.action}>
                {action}
            </div>}
        </div>
    );
};

WorkspaceTile.propTypes = {
    ...defaultAriaProps,
    header: PropTypes.string,
    variant: PropTypes.oneOf(['default', 'info', 'search', 'comingSoon']),
    'data-testid': PropTypes.string
};

WorkspaceTile.defaultProps = {
    variant: 'default'
};

export default WorkspaceTile;
